import type { FunctionComponent } from "react"

import Skeleton, { SkeletonTheme } from "react-loading-skeleton"

import { Text } from "@jobteaser/spark/components/Text"

import { CardLoading } from "@/modules/jobAds/client/components/CardLoading/CardLoading"
import { MAIN_THEME } from "@/modules/Loading/constants/skeleton"

import styles from "./ResultsLoading.module.css"

const JOB_AD_CARD_NUMBER = 10

const JOB_AD_RESULTS_HEADER_COUNT_SKELETON_WIDTH = 150
const JOB_AD_RESULTS_HEADER_SORT_SKELETON_WIDTH = 100

export const ResultsLoading: FunctionComponent = () => {
  const createJobAdSkeletons = (amount: number): JSX.Element[] =>
    Array(amount)
      .fill(undefined)
      .map((_item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <CardLoading key={index} />
      ))

  return (
    <SkeletonTheme {...MAIN_THEME} data-testid="job-ads-loader">
      <div className={styles.resultsLoading__header}>
        <Text variant="body2">
          <Skeleton width={JOB_AD_RESULTS_HEADER_COUNT_SKELETON_WIDTH} />
        </Text>
        <Text variant="body2" className={styles.resultsLoading__sort}>
          <Skeleton width={JOB_AD_RESULTS_HEADER_SORT_SKELETON_WIDTH} />
        </Text>
      </div>
      {createJobAdSkeletons(JOB_AD_CARD_NUMBER)}
    </SkeletonTheme>
  )
}
